<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <div v-for="(data,name) in filter">
      <v-card class="pa-2 primary" outlined tile
              v-for="value in data.current">
        <v-icon class="float-right" @click="setFilter(name,value.key)">mdi-close</v-icon>
        {{ value.text }}
      </v-card>
    </div>


    <v-expansion-panels accordion multiple tile class="option_filter">

      <v-expansion-panel v-for="(data,name) in filter" v-if="data.options.length>data.current.length+1">
        <v-expansion-panel-header outlined tile>{{ data.label }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-list>
            <v-list-item link

                         v-for="option in data.options"
                         @click="setFilter(name,option.key,option.text)"
            >
              <v-list-item-content>
                <v-list-item-title>{{ option.text }}({{ option.count }})</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>

    </v-expansion-panels>

  </div>

</template>
<style lang="scss" scoped>
.option_filter {
  margin: 0 1px;
  padding: 0 2px 0 0;

  .v-expansion-panel-header {
    /*padding: 16px 24px;*/
    padding: 4px 8px;
  }

  .v-expansion-panel-content {
    /*padding: 0 8px 4px;*/
    /*padding: 0 24px 16px;*/
    padding: 0;

  }

  .v-list-item {
    /*padding: 0 16px;*/
    padding: 0 4px;
  }
}
</style>

<script lang="ts">

import {FilterCustomer} from '@/models/Customer'
import {FilterOrder} from '@/models/Order'
import {FilterProduct} from '@/models/Product'
import {Component, Prop, Vue} from 'vue-property-decorator'


@Component({
  components: {}
})
export default class FilterCurrent extends Vue {
  @Prop() filter: FilterOrder | FilterCustomer | FilterProduct
  @Prop() setFilter: (name: string, key: string, text?: string) => void


}

</script>
